;(function () {
  angular.module('contrast.filters').filter('withLength', function ($filter) {
    return function (array, query, length) {
      if (!length) {
        length = 2
      }

      if (query.length >= length) {
        return $filter('filter')(array, query)
      }

      return array
    }
  })
})()
